export function getKeyByValue<T, U extends T[keyof T]>(object: T, value: U) {
  const keys = Object.keys(object) as (keyof typeof object)[];

  return keys.find((key) => object[key] === value);
}

/*
 * object key값을 kebab 변환
 */
export function switchToKebab(obj?: Record<string, any>, prefix?: string) {
  if (!obj) {
    return {};
  }
  const keys = Object.keys(obj);

  return keys.reduce((a, key) => {
    const newKey: string =
      (prefix ?? '') +
      key
        .replace(/^([A-Z])/g, ($1) => $1.toLowerCase())
        .replace(/\_/g, '-')
        .replace(/([A-Z])/g, ($1) => {
          return `-${$1.toLowerCase()}`;
        });

    a[newKey] = obj[key];

    return a;
  }, {} as Record<string, any>);
}

/**
 * value가 undefined인 property 제거
 * @param obj
 */
export function cleaningObj(obj: Record<string, any>) {
  if (!obj) {
    return {};
  }

  Object.keys(obj).forEach((key) => obj[key] === undefined && delete obj[key]);

  return obj;
}
